module.exports = __webpack_public_path__ + "img/sieckFinesseAdaptation14.234938f9.png";